import { defaults, resolveMargin } from './space.esm.js';
import { system, compose } from './system-core.esm.js';
import { memoizedGet } from '../utils/object.esm.js';
import { resolveSizeValue } from '../utils/size-utils.esm.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
var emMarginTransform = function emMarginTransform(n, scale, props) {
  var v = resolveSizeValue(props.theme || props)(n, 'sizes.space');
  return defaults.space !== scale ? resolveMargin(v, scale, props) : props.theme && Array.isArray(props.theme.space) ? resolveMargin(v, props.theme.space, props) : resolveMargin(v, defaults.space, props);
};
var emPaddingTransform = function emPaddingTransform(n, scale, props) {
  var v = resolveSizeValue(props.theme || props)(n, 'sizes.space');
  return defaults.space !== scale ? memoizedGet(scale, v, v) : props.theme && Array.isArray(props.theme.space) ? memoizedGet(props.theme.space, v, v) : memoizedGet(defaults.space, v, v);
};
var configs = {};
configs.emMargin = {
  emMargin: {
    property: 'margin',
    scale: 'emSpace',
    transform: emMarginTransform,
    defaultScale: defaults.space
  },
  emMarginTop: {
    property: 'marginTop',
    scale: 'emSpace',
    transform: emMarginTransform,
    defaultScale: defaults.space
  },
  emMarginRight: {
    property: 'marginRight',
    scale: 'emSpace',
    transform: emMarginTransform,
    defaultScale: defaults.space
  },
  emMarginBottom: {
    property: 'marginBottom',
    scale: 'emSpace',
    transform: emMarginTransform,
    defaultScale: defaults.space
  },
  emMarginLeft: {
    property: 'marginLeft',
    scale: 'emSpace',
    transform: emMarginTransform,
    defaultScale: defaults.space
  },
  emMarginX: {
    properties: ['marginLeft', 'marginRight'],
    scale: 'emSpace',
    transform: emMarginTransform,
    defaultScale: defaults.space
  },
  emMarginY: {
    properties: ['marginTop', 'marginBottom'],
    scale: 'emSpace',
    transform: emMarginTransform,
    defaultScale: defaults.space
  }
};
configs.emPadding = {
  emPadding: {
    property: 'padding',
    scale: 'emSpace',
    transform: emPaddingTransform,
    defaultScale: defaults.space
  },
  emPaddingTop: {
    property: 'paddingTop',
    scale: 'emSpace',
    transform: emPaddingTransform,
    defaultScale: defaults.space
  },
  emPaddingRight: {
    property: 'paddingRight',
    scale: 'emSpace',
    transform: emPaddingTransform,
    defaultScale: defaults.space
  },
  emPaddingBottom: {
    property: 'paddingBottom',
    scale: 'emSpace',
    transform: emPaddingTransform,
    defaultScale: defaults.space
  },
  emPaddingLeft: {
    property: 'paddingLeft',
    scale: 'emSpace',
    transform: emPaddingTransform,
    defaultScale: defaults.space
  },
  emPaddingX: {
    properties: ['paddingLeft', 'paddingRight'],
    scale: 'emSpace',
    transform: emPaddingTransform,
    defaultScale: defaults.space
  },
  emPaddingY: {
    properties: ['paddingTop', 'paddingBottom'],
    scale: 'emSpace',
    transform: emPaddingTransform,
    defaultScale: defaults.space
  }
};
var emMargin = system(configs.emMargin);
var emPadding = system(configs.emPadding);
var emSpace = compose(emMargin, emPadding);

export default emSpace;
export { emMargin, emMarginTransform, emPadding, emPaddingTransform, emSpace };
//# sourceMappingURL=em-space.esm.js.map
